import { Text, TextSpacingType, TextType } from '@hg/stylizator/typography'
import { themeColors } from '@hg/stylizator/utils'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { getMarkupTextContent, IAttributes } from './Attributes'

import { IWPGBlockAttributesCompare } from 'app/helpers/IWPGBlockAttributesCompare'

const TextBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <Text
      type={TextType[attributes.textType as keyof typeof TextType]}
      spacingType={TextSpacingType[attributes.spacing as keyof typeof TextSpacingType]}
      useCompact={attributes.useCompact}
      color={attributes?.color || themeColors.gray['90']}
      align={attributes.align}
    >
      {getMarkupTextContent(attributes.elementType, attributes.content)}
    </Text>
  )
}

export default React.memo(TextBlock, IWPGBlockAttributesCompare)
